module.exports = __webpack_public_path__ + "static/media/main_features_gift.4905bcf7.svg";